import {Record} from 'immutable';

export default Record(
  {
    name: '',
    message: '',
  },
  'ConsoleError',
);
